import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Task } from '../shared/models/task.model';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  constructor() {}

  getActivity(id: string): Observable<Task> {
    return of({
      taskName: 'Inicio de la fase de instalación de encogrado',
      taskDescription: 'PIN276 Cimentación Semana 10',
      assignedToName: 'Francisco',
      assignedToImage: '',
      assignedToRole: 'Residente',
      status: 0,
      endDate: new Date(),
    }).pipe(delay(500));
  }

  getAllRecentActivities(projectId: number | 'all'): Observable<Task[]> {
    return of([
      {
        taskName: 'A-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 0,
        endDate: new Date(),
      },
      {
        taskName: 'B-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 1,
        endDate: new Date(),
      },
      {
        taskName: 'C-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 2,
        endDate: new Date(),
      },
      {
        taskName: 'D-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 3,
        endDate: new Date(),
      },
      {
        taskName: 'E-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 4,
        endDate: new Date(),
      },
      {
        taskName: 'F-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 5,
        endDate: new Date(),
      },
      {
        taskName: 'G-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 6,
        endDate: new Date(),
      },
      {
        taskName: 'H-Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 7,
        endDate: new Date(),
      },
      {
        taskName: 'Inicio de la fase de instalación de encogrado',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 8,
        endDate: new Date(),
      },
    ]).pipe(delay(500));
  }

  getAllExpiredActivities(): Observable<Task[]> {
    return of([
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 0,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 1,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 2,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 3,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 4,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 5,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 6,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 7,
        endDate: new Date(),
      },
      {
        taskName: 'Expirada',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 8,
        endDate: new Date(),
      },
    ]).pipe(delay(500));
  }

  getAllUpcomingActivities(): Observable<Task[]> {
    return of([
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 0,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 1,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 2,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 3,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 4,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 5,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 6,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 7,
        endDate: new Date(),
      },
      {
        taskName: 'Próxima',
        taskDescription: 'PIN276 Cimentación Semana 10',
        assignedToName: 'Francisco',
        assignedToImage: '',
        assignedToRole: 'Residente',
        status: 8,
        endDate: new Date(),
      },
    ]).pipe(delay(500));
  }
}
